import routerOptions0 from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.7.5_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_0b0b9ac3fd6bb8082394f70e1fd5c0fa/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}